/**
 * @fileoverview POST handler for the "/apps/business/accounts" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsLegacyCatalogAccountsCacheKeys } from "./constants";
import type { PostLegacyCatalogAccountsProps, LegacyCatalogAccountsResult } from "./types";

export const postLegacyCatalogAccounts = reactQueryMutationAdapter(
  appsLegacyCatalogAccountsCacheKeys,
  (props: PostLegacyCatalogAccountsProps): Promise<LegacyCatalogAccountsResult> => {
    return fetch("/apps/business/accounts", "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
